export const types = {
  CHANGE_BANNER: 'CHANGE_BANNER',
  UNMUTE_VIDEO: 'UNMUTE_VIDEO',
  MUTE_VIDEO: 'MUTE_VIDEO',
};

export const actions = {
  changeBanner: banner => ({
    type: types.CHANGE_BANNER,
    payload: {
      banner,
    },
  }),
  muteVideo: () => ({ type: types.MUTE_VIDEO }),
  unmuteVideo: () => ({ type: types.UNMUTE_VIDEO }),
};

const initialState = {
  banner: {},
  isMute: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_BANNER:
      return {
        ...state,
        banner: action.payload.banner,
      };
    case types.UNMUTE_VIDEO:
      return {
        ...state,
        isMute: false,
      };
    case types.MUTE_VIDEO:
      return {
        ...state,
        isMute: true,
      };
    default:
      return state;
  }
};

export default reducer;

export const getBanner = state => state.banner.banner;
export const getMute = state => state.banner.isMute;



// WEBPACK FOOTER //
// ./app/redux/banner.js